import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useLocale } from 'src/contexts/LocaleContext'
import { graphQLClient } from 'src/data/graphql/graphql-client'
import { CartDiscountCodesUpdateDocument } from 'src/data/graphql-generated'
import { onCartMutationSuccess } from 'src/functions/cart/onCartMutationSuccess'

import type { Cart, CartDiscountCodesUpdateMutationVariables, CartWarning, UserError } from 'src/data/graphql-generated'

export type CartDiscountCodesUpdateMutationFn = (
  variables: CartDiscountCodesUpdateMutationVariables,
) => Promise<{ cart: Cart; warnings: CartWarning[]; userErrors: UserError[] }>

export const useCartDiscountCodesUpdateMutation = () => {
  const queryClient = useQueryClient()
  const { langCode } = useLocale()

  const mutationFn: CartDiscountCodesUpdateMutationFn = async (variables) => {
    const {
      cartDiscountCodesUpdate,
    }: { cartDiscountCodesUpdate: { cart: Cart; warnings: CartWarning[]; userErrors: UserError[] } } =
      await graphQLClient.request(CartDiscountCodesUpdateDocument, {
        cartId: variables.cartId,
        discountCodes: variables.discountCodes,
        lang: langCode,
      })

    return cartDiscountCodesUpdate
  }

  return useMutation({
    mutationFn,
    onSuccess: ({ cart, userErrors }) => onCartMutationSuccess(queryClient, cart, userErrors),
  })
}
